import {combineReducers} from 'redux'
import holidayListPanel from './components/panels/holidayList/reducer'
import importHolidaysPanel from './components/panels/importHolidays/reducer'
import {createWorkScheduleReducer} from './reducer'

export default (initAppData) => combineReducers({
    page: createWorkScheduleReducer(initAppData),
    holidayListPanel,
    importHolidaysPanel,
})


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/workScheduleReducer.js